import numeral from 'numeral';
import numeralConfig from '@/config/numeralConfig';
import appConfig from '@/config/appConfig';

numeral.register('locale', 'nextera', {
  ...numeralConfig
});

numeral.locale('nextera');

// numeraljs formatting
const currencyFormat = '$0.[0] a';
const currencyFormatSubMil = '$0,0';
const integerFormat = '0,0 a';
const integerFormatSubMil = '0,0';
const percentFormat = '0.[0]%';

const configFormats = {
  percentFormat,
  currencyFormat,
  integerFormat
};

export default class numeralHelper {
  static getFormattedNumber(value, field, format) {
    // console.log(`${field} - ${format} : ${value}`);
    if (!value) return '';
    if (configFormats[format]) {
      if (format === 'integerFormat' && value < 1000000) {
        return numeral(value).format(integerFormatSubMil, Math.floor);
      } else if (format === 'currencyFormat' && value < 1000000) {
        return numeral(value).format(currencyFormatSubMil, Math.floor);
      } else {
        return numeral(value).format(configFormats[format], Math.floor);
      }
    }
    return numeral(value).value();
  }
}
